// extracted by mini-css-extract-plugin
module.exports = {"container":"unsubscribed-warning-banner_container__a0mqJ","dialog":"unsubscribed-warning-banner_dialog__tlPQk","closeButton":"unsubscribed-warning-banner_closeButton__VYIHD"};